import React, { Component } from "react";
import { apiUrl } from "../../../utils/apiUrl";
import { formatDate, toast } from "../../../utils/helpers";
import { postRequest, withRequest } from "../../../utils/request";
import Loader from "../../general/Loader";
import Modal from "../../general/Modal";
import Form from "./Form";
import SearchCedula from "./SearchCedula";

class CreateModal extends Component {
    state = {
        errors: {},
        tutor: {},
        tipos: [],
        showSearch: false,
        search: "",
        searchResults: null,
        searchSuccess: null,
        searching: false,
    };
    createTutor = async (event) => {
        event.preventDefault();

        const data = new FormData(event.target);
        const response = await postRequest(apiUrl("academico/padres-tutores"), data);

        if (response.success) {
            this.props.toggleModal('CreateTutor', response.data);
            toast("Tutor creado correctamente.");
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
            toast("Tutor no pudo ser creado.", "error");
        }
    };
    toggleSearchModal = () => {
        this.setState({
            showSearch: !this.state.showSearch,
        });
    };
    buscarTutor = async (e) => {
        e.preventDefault();

        this.setState({
            searching: true,
        });

        const { search } = this.state;
        const url = `https://app.migente.com.do/api/getpadronexterno/?cedula=${search}&user=felipe_api&pswd=F3l1pe`;
        const response = await fetch(url);
        response.json().then((res) => {
            this.setState({
                searchResults: res.Persona,
                searchSuccess: res.Existe,
                searching: false,
            });
        });
    };
    insertarTutor = () => {
        const search = this.state.searchResults;

        if (!search) {
            return;
        }

        this.setState(prevState => {
            return {tutor: {
                ...prevState.tutor,
                nombre: search.Nombres,
                apellido:
                    search.Apellido1 +
                    " " +
                    (search.Apellido2 ? search.Apellido2 : ""),
                cedula: search.Cedula,
                fechaNacimiento: formatDate(Date.parse(search.FechaNacimiento)),
                direccion: search.Municipio + ", " + search.Provincia,
                foto: search.Imagen,
                fotoCed: search.Imagen,
                nacionalidad: "Dominicano",
            }}
        });
        this.toggleSearchModal();
    };
    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };
    render() {
        const {
            errors,
            tutor,
            searchResults,
            searching,
            searchSuccess,
        } = this.state;
        return (
            <div>
                <form
                    method='post'
                    onSubmit={this.createTutor}
                    encType='multipart/form-data'>
                        <div className='popup__header'>Crear Padre/Tutor</div>
                        <div className="popup__body">
                            <Form
                                tutor={tutor}
                                errors={errors}
                                toggleSearchModal={this.toggleSearchModal}
                            />
                        </div>
                        <div className='popup__footer'>
                            <button
                                type='button'
                                onClick={() => this.props.toggleModal('CreateTutor')}
                                className='btn btn-plain'>
                                Cancelar
                            </button>
                            <button
                                type='submit'
                                className='btn btn-primary'>
                                Insertar
                            </button>
                        </div>
                </form>
                <Modal
                    show={this.state.showSearch}
                    blank={true}
                    toggle={this.toggleSearchModal}>
                    <SearchCedula
                        searching={searching}
                        searchResults={searchResults}
                        searchSuccess={searchSuccess}
                        onInputChange={this.onInputChange}
                        buscarTutor={this.buscarTutor}
                        insertarTutor={this.insertarTutor}
                        toggleSearchModal={this.toggleSearchModal}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRequest(CreateModal);
